import React, { useState } from 'react';
import { NavigationStepperItemType } from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import LaboratoryRequestCreateModal from '../../../Laboratory/Components/LaboratoryRequestCreate/LaboratoryRequestCreateModal';
import IssuedLaboratoryRequestsList from '../../../Laboratory/Components/IssuedLaboratoryRequestsList/IssuedLaboratoryRequestsList';
import LaboratoryResultsListWrapper from '../../../Laboratory/Components/LaboratoryResultsList/LaboratoryResultsListWrapper';
import Loading from '../../../../Components/Loading';

interface Props {
	patientId: string;
	workplaceId: string;
}

const PatientTreatmentLaboratories: React.FC<Props> = ({
	patientId,
	workplaceId,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isCreateLaboratoryRequestOpen, setIsCreateLaboratoryRequestOpen] =
		useState(false);

	const handleOnCreateRequest = async () => {
		setIsLoading(true);
		setIsCreateLaboratoryRequestOpen(false);
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	};

	let steps: NavigationStepperItemType[] = [
		{
			name: 'component.medicalRequestForms.createARequisition',
			key: 'newLaboratoryRequest',
			onClick: () => setIsCreateLaboratoryRequestOpen(true),
		},
		{
			name: 'component.patientTreatmentLaboratories.issuedLaboratoryRequests',
			key: 'issuedLaboratoryRequests',
			component: () => (
				<IssuedLaboratoryRequestsList
					workplaceId={workplaceId}
					patientId={patientId}
				/>
			),
		},
		{
			name: 'component.patientTreatmentLaboratories.laboratoryResults',
			key: 'laboratoryResults',
			component: () => <LaboratoryResultsListWrapper patientId={patientId} />,
		},
	];

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='issuedLaboratoryRequests'
				canSkip
				showStepNumbers={false}
			/>
			<LaboratoryRequestCreateModal
				isOpen={isCreateLaboratoryRequestOpen}
				onClose={() => setIsCreateLaboratoryRequestOpen(false)}
				onRequestCreate={handleOnCreateRequest}
				patientId={patientId}
			/>
		</>
	);
};

export default PatientTreatmentLaboratories;
